<template>
  <a-card
      class="subscription-active-card"
      :style="{
        '--subscription-color': subscription.color,
        '--subscription-tag-background': subscription.tagBackground,
      }"
      :bordered="true"
  >
    <div class="subscription-active-card__content">
      <h3>{{ subscription.title }}</h3>

      <div class="subscription-active-card__bottom">
        <div class="subscription-active-card__info">
        <div class="subscription-active-card__quota">
          <span>{{ subscription.used }}</span> / {{ subscription.total }}
        </div>

        <p>{{ subscription.expires }}</p>
        </div>

        <div class="subscription-active-card__actions">
        <a-dropdown
            :trigger="['click']"
            placement="bottomLeft"
        >
          <a-button
              class="secondary-button subscription-active-card__icon"
              size="small"
              @click.prevent
          >
            <MoreOutlined />
          </a-button>

          <template #overlay>
            <a-menu>
              <a-menu-item key="details">
                Подробнее о подписке
              </a-menu-item>

              <a-menu-item
                  key="disable"
                  @click="openDisableModal"
              >
                Отключить
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>

        <a-button
            class="subscription-active-card__add"
            size="small"
            @click="order"
        >
          <PlusOutlined />
        </a-button>
        </div>
      </div>
    </div>

    <DisableSubscriptionModal
        :open="showDisableModal"
        :name="subscription.title"
        @close="closeDisableModal"
        @done="closeDisableModal"
    />
  </a-card>
</template>

<script>
import { ref } from 'vue';
import { MoreOutlined, PlusOutlined } from '@ant-design/icons-vue';

import DisableSubscriptionModal from '@/views/Catalog/ProductCard/DisableSubscriptionModal.vue';

export default {
  name: 'SubscriptionActiveCard',
  components: {
    DisableSubscriptionModal,
    MoreOutlined,
    PlusOutlined,
  },
  emits: ['order'],
  props: {
    subscription: {
      type: Object,
      required: true,
    },
  },
  setup(props, context) {
    const showDisableModal = ref(false);

    const order = () => {
      context.emit('order', props.subscription);
    };

    const openDisableModal = () => {
      showDisableModal.value = true;
    };

    const closeDisableModal = () => {
      showDisableModal.value = false;
    };

    return {
      closeDisableModal,
      openDisableModal,
      order,
      showDisableModal,
    };
  },
};
</script>

<style scoped lang="scss">
.subscription-active-card {
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-color: var(--subscription-tag-background);
}

.subscription-active-card::before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  height: 4px;
  background: var(--subscription-tag-background);
}

.subscription-active-card :deep(.ant-card-body) {
  height: 100%;
}

.subscription-active-card__content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

h3 {
  margin-bottom: 12px;
  font-weight: 600;
  font-size: 16px;
  line-height: 120%;
  color: rgba(0, 0, 0, 0.88);
}

.subscription-active-card__bottom {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  margin-top: auto;
}

.subscription-active-card__quota {
  margin-bottom: 4px;
  font-weight: 600;
  font-size: 20px;
  line-height: 120%;
  color: rgba(0, 0, 0, 0.45);
}

.subscription-active-card__quota span {
  color: var(--subscription-color);
}

p {
  margin: 0;
  color: rgba(0, 0, 0, 0.45);
  font-weight: 400;
  font-size: 14px;
  line-height: 120%;
  color: rgba(0, 0, 0, 0.45);
}

.subscription-active-card__actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}

.subscription-active-card__icon,
.subscription-active-card__add {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
}

.subscription-active-card__icon {
  color: rgba(0, 0, 0, 0.45);
}

.subscription-active-card__add,
.subscription-active-card__add:hover,
.subscription-active-card__add:active,
.subscription-active-card__add:focus {
  color: #ffffff;
  border-color: var(--subscription-color);
  background: var(--subscription-color);
}
</style>
